import 'jquery';
import Swiper from "swiper";
import Modal from "bootstrap/js/src/modal";
import {createElement} from "../util/utils";
import {blockEl, unblockEl} from "./Block";

const { __ } = wp.i18n;

export default class ReviewList {
    constructor()
    {
        this.reviewSection   = document.querySelector('#reviews');
        this.commentWrap     = document.querySelector('#commentWrap');
        if ( !this.reviewSection || !this.commentWrap ) {
            return;
        }

        this.commentLists    = this.commentWrap ? this.commentWrap.querySelector('.commentlist') : null;
        this.loadMoreWrap    = document.querySelector('#comment-load-more');
        this.resultCount     = document.querySelector('.reviews-list__title');
        this.resultCountAvg  = document.querySelector('.reviews-average__count');
        this.filterClearWrap = document.querySelector('#ratingFilterClearWrap');

        this.modal = null;
        this.attachHandlers();
    }

    attachHandlers()
    {
        this.commentWrap.addEventListener('click', this.onLoadButtonClick.bind(this));
        this.commentWrap.addEventListener('click', this.onLessButtonClick.bind(this));
        this.reviewSection.addEventListener('click', this.onLoadReviewModalButtonClick.bind(this));
        this.reviewSection.addEventListener('click', this.onClearAllFiltersButtonClick.bind(this));
        document.body.addEventListener('palram_rating_filters_changed', this.onFilteresChange.bind(this));
    }
    /**
     * ## Reviews Pages Pagination
     */
    async onLoadButtonClick( event )
    {
        if (!event.target.classList.contains('ajax-load-comments')) {
            return;
        }
        event.preventDefault();
        const page = event.target.dataset.commentPage || 0;

        await this.getFilteredComments(page, false);
    }

    onLessButtonClick( event )
    {
        if (!event.target.classList.contains('ajax-less-comments')) {
            return;
        }
        event.preventDefault();
        this.reviewSection.scrollIntoView({ behavior: "smooth",});

        // const page = event.target.dataset.commentPage;
        //
        // await this.getFilteredComments(page, false, true);
    }

    onClearAllFiltersButtonClick( event )
    {
        if(!event.target.classList.contains('btn-clear-filter')) {
            return;
        }
        event.preventDefault();
        document.body.dispatchEvent( new CustomEvent('palram_rating_filters_clear'));
    }

    async onFilteresChange()
    {
        await this.getFilteredComments(0, true);
    }

    async getFilteredComments(page, override, destroy)
    {
        blockEl(this.reviewSection);

        if (override) {
            await this.getCommentPage(0);
        }

        try {
            let response = await this.getCommentPage(page);
            if (!destroy) {
                this.updateResults(response, override, page);
            } else {
                this.clearResult(response, page);
            }
        } catch (e) {
            this.requestError(e);
        } finally {
            unblockEl(this.reviewSection);
        }
    }

    updateResults(results, override, page)
    {
        const parser = new DOMParser();
        const doc = parser.parseFromString(results, 'text/html');
        const ratingFilterClearWrap = doc.querySelector('#ratingFilterClearWrap');

        let commentList = doc.querySelector('.commentlist');
        let comments;

        if (override) {
            if (!commentList) {
                commentList = createElement({
                    classes: ['commentlist', 'list-unstyled'],
                    innerHTML: `<p class="woocommerce-noreviews">${__('There are no reviews yet.', 'canopia')}</p>`,
                });
            }

            this.commentLists.replaceWith(commentList);
            this.commentLists = commentList;

            // Update Result Count
            const resultCount    = doc.querySelector('.reviews-list__title');
            const resultCountAvg = doc.querySelector('.reviews-average__count');
            if ( this.resultCount && resultCount) {
                this.resultCount.replaceWith(resultCount);
                this.resultCount = resultCount;
            }

            if (this.resultCountAvg && resultCountAvg) {
                this.resultCountAvg.replaceWith(resultCountAvg);
                this.resultCountAvg = resultCountAvg;
            }

            // Update Rating Filter Clear Wrap
            if (ratingFilterClearWrap) {
                this.filterClearWrap.replaceWith(ratingFilterClearWrap);
                this.filterClearWrap = ratingFilterClearWrap;
            }
        } else {
            comments = commentList.querySelectorAll('.review');

            if (comments && comments.length > 0) {
                this.commentLists.append(...comments);
                comments.forEach(commentItem => {
                    commentItem.classList.add(`comment-page-${page}`);
                    commentItem.setAttribute('data-comment-page', page);
                });
            }
        }

        // Update Load More Wrapper
        this.loadMoreWrap = document.querySelector('#comment-load-more');
        let loadMoreWrap = doc.querySelector('#comment-load-more');

        if (loadMoreWrap) {
            if (this.loadMoreWrap) {
                this.loadMoreWrap.replaceWith(loadMoreWrap);
            } else {
                this.commentWrap.appendChild(loadMoreWrap);
            }
            this.loadMoreWrap = loadMoreWrap;
        } else {
            this.loadMoreWrap.classList.remove('d-flex', 'justify-content-between');
            this.loadMoreWrap.setAttribute('style', 'display: none;');
        }
    }

    clearResult(results, page)
    {
        const parser = new DOMParser();
        const doc = parser.parseFromString(results, 'text/html');

        let commentList = this.commentLists;
        let comments = commentList.querySelectorAll('.review');

        if (comments && comments.length > 0) {
            comments.forEach(commentItem => {
                if (commentItem.dataset && commentItem.dataset.commentPage && page < commentItem.dataset.commentPage) {
                    commentItem.remove();
                }
            })
        }

        // Update Load More Wrapper
        this.loadMoreWrap = document.querySelector('#comment-load-more');
        const loadMoreWrap = doc.querySelector('#comment-load-more');

        if (loadMoreWrap) {
            if (this.loadMoreWrap) {
                this.loadMoreWrap.replaceWith(loadMoreWrap);
            } else {
                this.commentWrap.appendChild(loadMoreWrap);
            }
            this.loadMoreWrap = loadMoreWrap;
        }
    }

    // setCommentPageQuery( page = 0 ) {
    //     let url = new URL(window.location.href);
    //     let pathname = url.pathname.replace(/\/$/, '');
    //
    //     let params = new URLSearchParams(url.search);
    //     url.searchParams.set('review_page', page);
    //     params.toString();
    //
    //     window.history.replaceState({}, '', `${pathname}/${url.search}`);
    // }

    async getCommentPage( page = 0)
    {
        let url = new URL(window.location.href);

        let params = new URLSearchParams(url.search);
        url.searchParams.set('review_page', page);
        params.toString();

        const response = await fetch(url.href, {
            method: 'GET',
        });

        return await response.text();
    }

    /**
     * ------------------------------------------------
     * ## Review Modal
     ------------------------------------------------
     */
    async onLoadReviewModalButtonClick( event )
    {
        if ( !event.target.classList.contains('load-review-modal') ) {
            return;
        }
        event.preventDefault();
        const reviewId = event.target.dataset.reviewId;

        await this.onLoadReviewModal(reviewId);
    }

    async onLoadReviewModal( review )
    {
        blockEl(this.reviewSection);
        try {
            let data = {
                action: `palram_get_reviews`,
                secure: palram.nonces.get_reviews,
                reviewId: review,
            };

            let response = await this.getReviewModalData(data);
            if (response.success) {
                this.open(response.data, review);
            }
        } catch (e) {
            console.log(e);
        }
        finally {
            unblockEl(this.reviewSection);
        }
    }

    async getReviewModalData(data)
    {
        return $.ajax({
            url: palram.ajax_url,
            method: 'GET',
            data,
        });
    }

    open(data)
    {
        if ( this.modal ) {
            this.close();
        }

        this.modal = this.createReviewModal(data);
        this.getReviewModalSlider(data);

        this.modal.show();
    }

    close()
    {
        if (!this.modal) {
            return;
        }

        let el = this.modal._element;

        if (this.modal._isShown) {
            this.modal.hide();
        }

        this.modal.dispose();
        this.modal = null;
        el.remove();
    }

    createReviewModal(data)
    {
        const modal = createElement({
            classes: ['modal', 'fade', 'review-modal'],
            attributes: {
                id: `review-modal-${data.id}`,
                tabindex: '-1',
                ariaHidden: true,
                style: 'display: block;',
            },
            parent: document.body,
        });
        const modalWidth = data.attId.length > 0 ? 'modal-xl' : 'modal-lg';
        const dialog = createElement({
            classes: ['modal-embed', 'modal-dialog', 'modal-dialog-centered', modalWidth],
            parent: modal,
        });
        const content = createElement({
            classes: ['modal-content', 'position-relative'],
            parent: dialog,
        });
        const header = createElement({
            classes: ['modal-header', 'position-absolute', 'w-100'],
            parent: content,
        });
        createElement({
            tagname: 'button',
            classes: ['btn-close'],
            attributes: {
                type: 'button',
                ariaLabel: __('Close', 'canopia'),
                style: 'z-index:100;',
            },
            dataset: {
                bsDismiss: 'modal',
            },
            parent: header,
        });
        const body = createElement({
            classes: ['modal-body', 'py-30', 'px-20', 'p-lg-50'],
            parent: content,
        });
        createElement({
            tagname: 'h5',
            classes: ['modal-title', 'sr-only'],
            textContent: data.title,
            parent: header,
        });
        if (data.html) {
            body.insertAdjacentHTML('beforeend', data.html)
        } else {
            createElement({
                tagname: 'p',
                classes: [],
                textContent: __('Not content of the review', 'canopia'),
                parent: body,
            })
        }

        return new Modal(modal);
    }
    /** ------------------------------------------------
     * ## Review Modal Gallery Slider
     ------------------------------------------------ */
    getReviewModalSlider(data)
    {
        const rwThumbs = document.getElementById(`review-modal-thumbs-${data.id}`);
        const rwSlider = document.getElementById(`review-modal-slider-${data.id}`);

        if (rwSlider) {
            let rwThumbsSlider = null;

            let rwSliderArgs = {
                loop: true,
                breakpoints: {
                    992: {
                        navigation: {
                            nextEl: document.getElementById(`review-slider-next-${data.id}`),
                            prevEl: document.getElementById(`review-slider-prev-${data.id}`),
                        },
                    },
                },
            };

            if (rwThumbs) {
                const rwThumbsPreView = 4;
                rwThumbsSlider = new Swiper(rwThumbs, {
                    loop: true,
                    spaceBetween: 15,
                    slidesPerView: 'auto',
                    freeMode: false,
                    watchSlidesProgress: true,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    breakpoints: {
                        992: {
                            slidesPerView: rwThumbsPreView,
                            spaceBetween: 20,
                            centeredSlides: rwThumbsPreView % 2 !== 0,
                        },
                    },
                });
                rwSliderArgs.thumbs = {
                    swiper: rwThumbsSlider,
                }
            }

            new Swiper(rwSlider, rwSliderArgs);
        }
    }

    requestError(error)
    {
        console.error(error);
    }
}
